import {Component, Inject, ChangeDetectionStrategy} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {TrunkNotice} from "@knust/api-interfaces";
import {FormBuilder, UntypedFormGroup, Validators} from "@angular/forms";

@Component({
    selector: 'knust-trunk-notice-dialog',
    templateUrl: './trunk-notice-dialog.component.html',
    styleUrls: ['./trunk-notice-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TrunkNoticeDialogComponent {
  trunkNoticeForm: UntypedFormGroup = this.fb.group({
    label: [null, Validators.required]
  });

  constructor(
    public dialogRef: MatDialogRef<TrunkNoticeDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data?: TrunkNotice,
  ) {
    if (data) {
      this.trunkNoticeForm.patchValue(data);
    }
  }

  cancel() {
    this.dialogRef.close();
  }

  save() {
    if (this.trunkNoticeForm.valid) {
      this.dialogRef.close({
        id: this.data?.id ?? null,
        ...this.trunkNoticeForm.value,
      });
    } else {
      this.trunkNoticeForm.markAsTouched();
    }
  }
}
